import { get, getArrayBuffer, post, put, postExport } from "./index";

export const getOrders = async (query, toast) => {
  return post("/order/listing", { ...query }, undefined, toast);
};

export const getOrdersExport = async (query, toast) => {
  return postExport("/order/listing/export", { ...query }, undefined, toast);
};

export const onUpdateCashOnDelivery = async (body, toast) => {
  return post("/order/cod", body, undefined, toast);
};

export const onUpdateOrderNotes = async (body, toast) => {
  return post("/order/note", body, undefined, toast);
};

export const onUpdateOrderStatus = async (body, toast) => {
  return put("/order/status", body, undefined, toast);
};

export const onUpdateOrderWeight = async (body, toast) => {
  return post("/order/weight", body, undefined, toast);
};

export const onUpdateTrackingNumber = async (body, toast) => {
  return put("/order/tracking", body, undefined, toast);
};

export const onPrintLabel = async (query, toast) => {
  return getArrayBuffer("/order/awb?order_ids=", query, undefined, toast);
};

export const onForceOrdersSync = async (body, toast) => {
  return put("/order/force-sync", body, undefined, toast);
};

export const onCompleteOrder = async (body, toast) => {
  return put("/order/billing", body, undefined, toast);
};

export const getCities = async (toast) => {
  return get("/lookups/governorates/v2", undefined, undefined, toast);
};

export const getCouriers = async (toast) => {
  return get("/lookups/couriers?country=EG", undefined, undefined, toast);
};

export const getStatus = async (toast) => {
  return get("/lookups/order/statuses", undefined, undefined, toast);
};

export const getDispute = async (query, toast) => {
  return get("/order/disputes", `?${new URLSearchParams(query).toString()}`, undefined, toast);
};

export const updateDispute = async (disputeId, data, toast) => {
  return put(`/order/disputes/${disputeId}/respond`, data, undefined, toast);
};

export const getSubStatus = async (toast, status, orderType = "delivery") => {
  let payload;
  if (status) {
    payload = {
      filters: {
        statuses: [
          {
            value: status,
          },
        ],
      },
    };
  }
  return post(
    `/lookups/order/sub-statuses?type=${orderType}`,
    payload,
    undefined,
    toast
  );
};

export const getRejectedReasons = async (toast, subStatus, orderType = "delivery") => {
  let payload;
  if (subStatus) {
    payload = {
      filters: {
        sub_statuses: [
          {
            value: subStatus,
          },
        ],
      },
    };
  }
  return post(
    `/lookups/order/rejection-reasons?type=${orderType}`,
    payload,
    undefined,
    toast
  );
};

export const getOrderDetailsLogs = async (orderId, toast) => {
  return get("/order/" + orderId + "/logs", undefined, undefined, toast);
};

export const getOrderDetails = async (orderId, toast) => {
  return get("/order/" + orderId + "/details", undefined, undefined, toast);
};
